module.exports = __webpack_public_path__ + "img/sensores_de_posicion.de622aca.jpg";